import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/34881ac6-ae26-405c-ab79-330b641503fe.png" 
              alt="Restaurant Logo" 
              className="h-12 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#menu" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-red-700' : 'text-white hover:text-red-200'}`}>Menu</a>
            <a href="#about" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-red-700' : 'text-white hover:text-red-200'}`}>About</a>
            <a href="#gallery" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-red-700' : 'text-white hover:text-red-200'}`}>Gallery</a>
            <a href="#location" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-red-700' : 'text-white hover:text-red-200'}`}>Location</a>
            <a href="#reviews" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-red-700' : 'text-white hover:text-red-200'}`}>Reviews</a>
          </div>
          <div className="flex items-center gap-3">
            <a href="tel:+1234567890" className={`hidden md:block px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${scrolled ? 'bg-red-700 text-white hover:bg-red-800' : 'bg-white text-red-700 hover:bg-red-50'}`}>
              Call Now
            </a>
            <button className={`md:hidden ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://readdy.ai/api/search-image?query=beautifully%20plated%20gourmet%20restaurant%20dish%20with%20fresh%20herbs%20and%20colorful%20vegetables%20on%20elegant%20white%20ceramic%20plate%20with%20artistic%20sauce%20drizzle%20professional%20food%20photography%20with%20natural%20window%20lighting%20shallow%20depth%20of%20field%20blurred%20warm%20restaurant%20background%20appetizing%20presentation%20high%20end%20dining%20experience&width=1920&height=1080&seq=hero-main-bg&orientation=landscape" 
          alt="Delicious Food" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Hero Content */}
      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-3xl">
            <h1 className="text-7xl md:text-8xl font-serif font-bold text-white mb-6 leading-tight" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
              Great Food Made Fresh
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed">
              Delicious meals, quality ingredients, and a welcoming dining experience.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="#menu" className="px-8 py-4 bg-red-700 text-white rounded-full text-base font-semibold hover:bg-red-800 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg">
                View Menu
                <i className="ri-arrow-right-line"></i>
              </a>
              <a href="#location" className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full text-base font-semibold hover:bg-white hover:text-red-700 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer">
                <i className="ri-map-pin-line"></i>
                Get Directions
              </a>
            </div>
          </div>
        </div>

        {/* Open Now Badge */}
        <div className="absolute bottom-8 right-8 bg-white rounded-full px-6 py-3 shadow-lg flex items-center gap-2">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
          </span>
          <span className="text-sm font-semibold text-gray-800">Open Now</span>
        </div>
      </div>
    </section>
  );
}